import React from 'react';
import SEO from "../common/SEO";
import Separator from "../elements/separator/Separator";
import CalltoActionThree from "../elements/calltoaction/CalltoActionThree";
import SplitOne from "../elements/split/SplitOne";
import ServiceOne from "../elements/service/ServiceOne";
import Layout from "./layout/Layout";
import SectionTitle from "../elements/sectionTitle/SectionTitle";



const DigitalMarketing = () => {
    return (
        <>
            <SEO title="CSMS Development"/>
            <Layout>
                {/* Start Slider Area  */}
                <div className="slider-area slider-style-1 height-850 bg_image" data-black-overlay="7" style={{backgroundImage: `url(${process.env.PUBLIC_URL}../images/bg/web-dev.webp)`}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="inner pt--80 text-center">
                                    <h1 className="title display-one">Maximize Your Growth Potential <br /> with Digital Marketing.</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Slider Area  */}
                <Separator/>
                {/* Start Service Area  */}
                <div className="service-area rn-section-gapTop">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="content">
                                    <h4 className="title">Are you prepared to transition from conventional marketing methods and embrace the world of digital, outcome-oriented marketing strategies?</h4>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <p className="mb--10">Get ahead of your competitors by utilizing our digital marketing strategies. Our team will help you effectively utilize various digital tools and channels, such as SEO, social media marketing (SMM), and content marketing. This will help you effectively communicate your message to a wider audience and generate interest in your business. So, take advantage of our digital marketing services and witness your business grow to new heights.</p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Service Area  */}

                <Separator/>
                {/* Start Service Area  */}
                <div className="rn-service-area rn-section-gap ">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-7">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle=""
                                    title="What Mixon Softwares Offers"
                                    description="Partner with us and take your business to new heights with our expert marketing strategies. Our passion and experience will drive growth and bring new customers to your business through increased online visibility. Maximize your online exposure and reach with our proven methods for online marketing success."/>
                            </div>
                            {/* Start Slider Area  */}
                            <div className="col-lg-5">
                                <img src="../images/digital/digital.png" alt="digital Images"/>
                            </div>
                            {/* End Slider Area  */}
                        </div>
                    </div>
                </div>
                {/* End Service Area  */}
                <Separator/>
                <CalltoActionThree/>
            </Layout>
        </>
    )
}
export default DigitalMarketing;
